export const DEFAULT_PARAMS = {
  sod: 2.0,
  sdd: 490.0,
  tiltX: 51.0,
  tiltY: 0.0,
  detWidth: 2803,
  detHeight: 2401,
  detPitch: 0.1,
  offsetU: 0.0,
  offsetV: 0.0,
  numAngles: 72,
};

export const PARAM_RANGES = {
  sod: { min: 0.5, max: 50, step: 0.1, label: "SOD", unit: "mm" },
  sdd: { min: 50, max: 1500, step: 1, label: "SDD", unit: "mm" },
  tiltX: { min: -89, max: 89, step: 0.5, label: "Tilt X", unit: "deg" },
  tiltY: { min: -89, max: 89, step: 0.5, label: "Tilt Y", unit: "deg" },
  detWidth: { min: 100, max: 4000, step: 1, label: "Detector Width", unit: "px" },
  detHeight: { min: 100, max: 4000, step: 1, label: "Detector Height", unit: "px" },
  detPitch: { min: 0.05, max: 1.0, step: 0.01, label: "Detector Pitch", unit: "mm/px" },
  offsetU: { min: -200, max: 200, step: 1, label: "Offset U", unit: "px" },
  offsetV: { min: -200, max: 200, step: 1, label: "Offset V", unit: "px" },
  numAngles: { min: 8, max: 180, step: 1, label: "Num. Angles", unit: "" },
};

export function buildAngles(numAngles) {
  const angles = new Array(numAngles);
  for (let i = 0; i < numAngles; i++) angles[i] = (360 * i) / numAngles;
  return angles;
}
